import React from 'react';
import PropTypes from 'prop-types';

const Note = ({ code, description }) => (
	code && (
		<li>{code} : {description}</li>
	)
);

Note.propTypes = {
	code: PropTypes.string,
	description: PropTypes.string,
};

const Diagnoses = ({
	patient_diag1, patient_diag1_description,
	patient_diag2, patient_diag2_description,
	patient_diag3, patient_diag3_description,
	patient_diag4, patient_diag4_description,
	patient_diag5, patient_diag5_description,
	patient_diag6, patient_diag6_description,
	patient_diag7, patient_diag7_description,
	patient_diag8, patient_diag8_description,
	patient_diag9, patient_diag9_description,
	patient_diag10, patient_diag10_description,
}) => (
	<ul>
		<Note code={patient_diag1} description={patient_diag1_description} />
		<Note code={patient_diag2} description={patient_diag2_description} />
		<Note code={patient_diag3} description={patient_diag3_description} />
		<Note code={patient_diag4} description={patient_diag4_description} />
		<Note code={patient_diag5} description={patient_diag5_description} />
		<Note code={patient_diag6} description={patient_diag6_description} />
		<Note code={patient_diag7} description={patient_diag7_description} />
		<Note code={patient_diag8} description={patient_diag8_description} />
		<Note code={patient_diag9} description={patient_diag9_description} />
		<Note code={patient_diag10} description={patient_diag10_description} />
	</ul>
);
Diagnoses.propTypes = {
	patient_diag1: PropTypes.string,
	patient_diag1_description: PropTypes.string,
	patient_diag2: PropTypes.string,
	patient_diag2_description: PropTypes.string,
	patient_diag3: PropTypes.string,
	patient_diag3_description: PropTypes.string,
	patient_diag4: PropTypes.string,
	patient_diag4_description: PropTypes.string,
	patient_diag5: PropTypes.string,
	patient_diag5_description: PropTypes.string,
	patient_diag6: PropTypes.string,
	patient_diag6_description: PropTypes.string,
	patient_diag7: PropTypes.string,
	patient_diag7_description: PropTypes.string,
	patient_diag8: PropTypes.string,
	patient_diag8_description: PropTypes.string,
	patient_diag9: PropTypes.string,
	patient_diag9_description: PropTypes.string,
	patient_diag10: PropTypes.string,
	patient_diag10_description: PropTypes.string,
};

export default Diagnoses;
